import styled from 'styled-components';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router';

export const StyledBreadcrumb = styled(Breadcrumb)`
  margin: 16px 0;
`;

export const StyledBreadcrumbLink = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
`;

export const StyledBreadcrumbLabel = styled('span')`
  margin-left: 8px;
  font-size: 12px;
`;
